export default __webpack_public_path__ + "static/media/2133.7e71279d.png";